import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { cancelPriceChange } from "../api/cancelPriceChange";

export const useCancelPriceChange = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ changeId, body }) => cancelPriceChange(changeId, body),
    onSuccess: () => {
      toast.success("Price change cancelled successfully!");
      queryClient.invalidateQueries({ queryKey: ["pendingPriceChanges"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to cancel price change.");
    },
  });
};

